import { useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogActions, FlexGrid, Typography, Button } from "@albo-ui/core";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { useUpdateCRM } from "./hooks/useUpdateCRM";
import { AfbUpdateCRMProps } from "./types";
import { closelightbox } from "../../../util/Functions";


export const AfbUpdateCRM = ({ open, onClose, customer, segments, companyGroups, crmData, reloadData, changeAlert, changeLoader }: AfbUpdateCRMProps) => {
    const { zPos, form, loading: loadingRequest, disabled, onHandleChange, onHandleUpdate } = useUpdateCRM(open, customer, crmData, companyGroups, reloadData, closelightbox, changeAlert);

    useEffect(() => {
        changeLoader(loadingRequest);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingRequest]);


    return (
        <Dialog onClose={onClose} open={open} style={{ display: zPos !== 45 ? "none" : null, maxHeight: "500px" }}>
            <DialogTitle>
                <FlexGrid style={{display: "grid"}}>
                    <Typography variant='h2'>Actualización de CRM</Typography>
                    <Typography variant='paragraph' color='primary'>{customer.corporate_name}</Typography>        
                </FlexGrid>
            </DialogTitle>

            <DialogContent>
                <FlexGrid>
                    <FormControl variant="outlined" fullWidth sx={{my: 2}}>
                        <InputLabel>Segmento</InputLabel>
                        <Select label={"Segmento"} value={(form && form["segment"]) || -1} onChange={onHandleChange.bind(this, "segment")} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 1}} fullWidth variant="outlined">
                            <MenuItem value={-1} disabled>Seleccione</MenuItem>
                            {segments?.map((i) => (
                                <MenuItem key={`segment-${i.k}`} value={i.k}>
                                    {i.v}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </FlexGrid>

                 <FlexGrid>
                    <FormControl variant="outlined" fullWidth >
                        <InputLabel>Grupo Empresarial</InputLabel>
                        <Select label={"Grupo Empresarial"} value={(form && form["company_group"]) || -1} onChange={onHandleChange.bind(this, "company_group")} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 1}} fullWidth variant="outlined">
                            <MenuItem value={-1} disabled>Seleccione</MenuItem>
                            {companyGroups?.map((i) => (
                                <MenuItem key={`group-${i.uuid}`} value={i.uuid}>
                                    {i.group_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </FlexGrid>
            </DialogContent>

            <DialogActions sx={{marginTop: "0px !important"}}>
                <FlexGrid fullHeight fullWidth justify="space-between" alignItems="flex-start" style={{ marginTop: 10, display: "flex", gap: 16 }}>
                    <FlexGrid item>
                        <Button onClick={closelightbox} buttonType="secondary" size="normal">Cancelar</Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={onHandleUpdate.bind(this)} disabled={disabled} size="normal">Actualizar</Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};

export default AfbUpdateCRM;
